import { connect } from 'react-redux'
import { selectIsForwarding } from 'selectors/page'

import Footer from './view'

const select = state => ({
  isForwarding: selectIsForwarding(state),
})

export default connect(select)(Footer)
